import React, { useEffect, useState } from 'react';
import Icon from './Icon/Icon';

const ScrollToTopButton: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const toggleVisibility = () => {
            setIsVisible(window.scrollY > 100);
        };

        const handleResize = () => {
            setIsMobile(window.innerWidth > 767);
        };

        window.addEventListener('scroll', toggleVisibility);
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('scroll', toggleVisibility);
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <>
            {isVisible && (
                <button
                    type="button"
                    onClick={scrollToTop}
                    className="position-fixed btn-theme bg-black w-50px min-h-50px rounded-circle"
                    style={{
                        bottom: isMobile ? '20px' : '180px',
                        right: '20px',
                    }}
                >
                    <Icon name="arrowTop" className="min-w-24px" />
                </button>
            )}
        </>
    );
};

export default ScrollToTopButton;
